// ABOUTME: Presentational stream breakdown list (stream name + order count) shown by the stream filters and by
// ABOUTME: dashboard cards. Kept apart from StreamFilter so importers needn't pull in Filter.js (a circular import).
import { Box, List, ListItem, ListItemButton, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { useGetOptionsWithCountQuery } from '../../../../../newapi/pickingjob/pickingjobSlice';
import Text from '../../../../theme/text/Text';
import CheckIcon from '@mui/icons-material/Check';

export const StreamDisplayData = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    const {data, isLoading, isFetching} = useGetOptionsWithCountQuery({type:'stream'});

    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                p:2,
                maxHeight:350,
                overflow:'auto',
            }}
        >
            <List
                sx={{
                    padding:0,
                    display:"flex",
                    flexDirection:"column",
                    gap:1.5,
                }}
            >
                {data?.data?.map((column, index) => (

                    <ListItem key={column.name + "index"} disablePadding
                    >
                        <ListItemButton
                            className={cx({
                            })}
                            sx={{
                                minWidth:250,
                                color:colors.txt["primary"],
                                fontWeight:400,
                                display:"flex",
                                justifyContent:"space-between",
                                fontSize:"14px",
                                pl:2,
                                pr:0.5,
                                height:40,
                                borderRadius:5,

                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,

                            }}
                        >
                            <Text>{column.name === "All" ? t("all") : column.name}</Text>

                            <Box
                                sx={{
                                    display:"flex",
                                    alignItems:'center',
                                    gap:1,
                                }}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        minWidth:32,
                                        display:"none",

                                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],

                                    }}
                                >
                                    <CheckIcon fontSize="small"/>

                                </Box>
                                <Box
                                    sx={{
                                        height:32,
                                        minWidth:32,
                                        px:1,
                                        background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'center',
                                        borderRadius:4,
                                    }}
                                >
                                    <Text>{column.count}</Text>


                                </Box>
                            </Box>

                        </ListItemButton>
                    </ListItem>

                ))}
            </List>

        </Box>
    );
};
